import { http } from '../helpers/HttpApi';

export interface IZReportRequest {
    storeId: number,
    registerId: string,
    registerName: string,
    batchId: number,
    receiptFormat: string,
}

const receiptApi = {
    getZReport: async (request: IZReportRequest) => {
        const result = await http
            .post(`/api/receipt/zreport`, request)
            .then(res => res?.data?.data);

        return result;
    }
};

export default receiptApi;
